import Desktop from './Desktop'
import Mobile from './Mobile'

const PageSelector = {
    Desktop,
    Mobile
}

export default PageSelector